import PropertyCartel from "./PropertyCartel";

export default PropertyCartel;
